import { createSlice } from "@reduxjs/toolkit";

// Slice for handling authentication-related state
const authSlice = createSlice({
  name: "auth",
  initialState: {
    singInLoading: false,        // Indicates whether sign-in (login) is in progress
    forgetLoading: false,        // Indicates whether forgot password request is in progress
    organizationsData: [],       // Stores list of organizations in case of multi-org login
  },
  reducers: {
    // Updates login loading state
    loginUserReducer: (state, { payload }) => {
      state.singInLoading = payload.singInLoading;
    },
    // Updates forget password loading state
    forgetUserReducer: (state, { payload }) => {
      state.forgetLoading = payload.forgetLoading;
    },
    // Stores organization data in case user has access to multiple orgs
    mutltiOrgReducer: (state, { payload }) => {
      state.organizationsData = payload.data;
    },
  },
});

// Export actions for use in dispatch
export const { loginUserReducer, forgetUserReducer, mutltiOrgReducer } =
  authSlice.actions;

// Selector to access auth slice from the store
export const authSelector = (state) => state.auth;

// Export reducer to be included in root reducer
const authReducer = authSlice.reducer;
export default authReducer;
